<template>
<div class="animated fadeIn">
  <div>
    <b-row>
      <b-col md="4"></b-col>
      <b-col md="4">
        <b-img rounded="circle" thumbnail :src="mainPath+DataFormData.url" fluid v-if="DataFormData.image" />
      </b-col>
      <b-col md="4"></b-col>
    </b-row>
  </div>
  <b-form v-bind:id="DataFormSchema.name" @submit.prevent="callMethod">
    <div v-for="field in DataFormSchema.fields" v-bind:key="field.name">
     <component :is="field.type" :field="field" :data.sync="DataFormData2[field.name]"></component>
   </div>
    <div class="form-group form-actions">
      <b-button type="submit" size="sm" class="center" variant="success">{{DataFormSchema.button}}</b-button>
    </div>
  </b-form>
</div>
</template>
<script>
import inputPasswordConfirm from "./inputPasswordConfirm";
import inputPassword from "./inputPassword";
import inputEmail from "./inputEmail";
import inputText from "./inputText";
import inputTel from "./inputTel";
import inputNumber from "./inputNumber";
import inputSelect from "./inputSelect";
import inputFile from "./inputFile";
import inputDate from "./inputDate";
import { getApiMainPath } from "@/api";

export default {
  name: "formDinamic",
  components: {
    passwordConfirmInput: inputPasswordConfirm,
    passwordInput: inputPassword,
    emailInput: inputEmail,
    textInput: inputText,
    telInput: inputTel,
    numberInput: inputNumber,
    selectInput: inputSelect,
    fileInput: inputFile,
    dateInput: inputDate
  },
  props: {
    typeEndPoint: { required: true },
    formSchema: { required: true },
    formData: { required: true },
    params: {}
  },
  data: function() {
    return {
      DataTypeEndPoint: "",
      DataFormSchema: {},
      DataFormData: {},
      DataParams: {},
      mainPath: ""
    };
  },
  mounted() {
    this.DataTypeEndPoint = this.typeEndPoint;
    this.DataFormSchema = this.formSchema;
    this.DataFormData = this.formData;
    this.DataParams = this.params;
    this.mainPath = localStorage.getItem("urlApi");
    this.mainPath = this.mainPath.replace("/api", "");
  },
  computed: {
    DataFormData2: function() {
      // `this` points to the vm instance
      return this.DataFormData;
    }
  },
  watch: {
    DataTypeEndPoint: function() {
      this.DataTypeEndPoint = this.typeEndPoint;
    },
    DataFormSchema: function() {
      this.DataFormSchema = this.formSchema;
    },
    DataFormData: function() {
      this.DataFormData = this.formData;
    },
    DataParams: function() {
      this.DataParams = this.params;
    }
  },
  methods: {
    validateFile: function(data) {
      let validate = false;
      data.forEach((element, key) => {
        if (key.includes("IFile")) {
          validate = true;
        }
      });
      return validate;
    },
    getBase64: function(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
          resolve(reader.result);
        };
        reader.onerror = function(error) {
          console.log("Error: ", error);
          resolve("");
        };
      });
    },
    getDataForm: function(formDataValues) {
      let json = {};
      formDataValues.forEach(function(value, key) {
        json[key] = value;
      });
      return json;
    },
    getStringJson: function(json) {
      return new Promise((resolve, reject) => {
        let miJson = JSON.stringify(json);
        resolve(miJson);
      });
    },
    sentToServer: function(object) {
      let self = this;
      self.getStringJson(object).then(response => {
        let json = response;
        self.$store
          .dispatch(self.DataTypeEndPoint, json)
          .then(response => {
            self.loading = false;
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    callMethod: function() {
      const form = document.getElementById(this.DataFormSchema.name);
      const formDataValues = new FormData(form);
      let object = {};
      let self = this;

      object = self.getDataForm(formDataValues);
      object["id"] = self.DataParams.id;

      if (this.validateFile(formDataValues)) {
        formDataValues.forEach(function(value, key) {
          //object[key] = value;
          if (key.includes("IFile")) {
            console.log("value",value)
            if(value.name!=""){
              self.getBase64(value).then(response => {
                object["image"] = response;
                self.sentToServer(object);
              });
            }else{
              self.sentToServer(object);
            }
          }
        })
      } else {
        this.sentToServer(object);
      }

      /*
      formDataValues.forEach(function(value, key) {
        object[key] = value;
        if(key.includes('filee')){
          self.getBase64(value).then(response => {
              object[key] = response
          })          
        }else{
         // 
        }
      });
      let json = JSON.stringify(object);
      this.$store
        .dispatch(this.DataTypeEndPoint, json)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });*/
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/base/form/Form.vue